'use client';

import { toSnakeCaseKeys } from 'es-toolkit/object';

import { useOnceEffect } from '@/hooks/useOnceEffect';
import type { PROMOTION_CREATIVE_SLOT } from '@/utils/analytics/gtm';
import {
  getCreativeSlotAndClear,
  GTM_EVENT_TYPE,
  trackGtmEvent,
} from '@/utils/analytics/gtm';

interface ViewPromotionGtmEventTriggerProps {
  promotionName: string;
  promotionId: string;
}

/**
 * 페이지에 진입 했을 때 GTM 이벤트를 자동으로 트리거하는 컴포넌트
 * SELECT_PROMOTION 이벤트에서 저장된 값을 가져오는 용도라서 따로 구현
 * VIEW_PROMOTION 이벤트 전용
 */
export const ViewPromotionGtmEventTrigger = ({
  promotionName,
  promotionId,
}: ViewPromotionGtmEventTriggerProps) => {
  useOnceEffect(() => {
    // VIEW_PROMOTION 이벤트는 SELECT_PROMOTION 이벤트에서 임시로 저장한 creativeSlot을 가져옴
    const creativeSlot: PROMOTION_CREATIVE_SLOT | undefined =
      (getCreativeSlotAndClear() as PROMOTION_CREATIVE_SLOT) ?? undefined;
    trackGtmEvent(
      GTM_EVENT_TYPE.VIEW_PROMOTION,
      toSnakeCaseKeys({
        promotionName,
        promotionId,
        creativeSlot,
      }),
    );
  });

  return null;
};
